// extracted by mini-css-extract-plugin
export default {"icon":"image-info_icon__hJLVQ"};